// Generated by purs version 0.15.15
var To = function (x) {
    return x;
};
var From = function (x) {
    return x;
};
var annTypeEquals = {
    proof: function (v) {
        return function (a) {
            return a;
        };
    },
    Coercible0: function () {
        return undefined;
    }
};
var proof = function (dict) {
    return dict.proof;
};
var to = function (dictAnnTypeEquals) {
    var proof1 = proof(dictAnnTypeEquals);
    return function (p) {
        var v = proof1(p)(function (a) {
            return a;
        });
        return v;
    };
};
var from = function (dictAnnTypeEquals) {
    var proof1 = proof(dictAnnTypeEquals);
    return function (p) {
        var v = proof1(p)(function (a) {
            return a;
        });
        return v;
    };
};
export {
    proof,
    to,
    from,
    annTypeEquals
};
